import { render, staticRenderFns } from "./PlayersList.vue?vue&type=template&id=56789880&scoped=true"
import script from "./PlayersList.vue?vue&type=script&lang=js"
export * from "./PlayersList.vue?vue&type=script&lang=js"
import style0 from "./PlayersList.vue?vue&type=style&index=0&id=56789880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56789880",
  null
  
)

export default component.exports